import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type Props = {
  children: React.ReactNode
}

export function ManageRecordSection(props: Props) {
  const { children } = props

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.6, mt: 1.6 }}>
      <Typography variant="subtitle3">Manage record upon scheduling</Typography>
      {children}
    </Box>
  )
}

ManageRecordSection.displayName = 'ManageRecordSection'
